import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

import { authApi } from '@/utilities/axios';
import { useAuthStore } from '@/modules/auth/store';
import { showToast } from '@/utilities/toast-handler';

const URL = process.env.VUE_APP_API_VERSION + '/tasks';

export const useCommentStore = defineStore('comment', () => {
    const authStore = useAuthStore();
    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });

    // states
    const comment = ref({
        company_id: null,
        comment: null,
        type:null,
        attachments: [],
    });
    const comments = ref([]);
    const loading = ref(false);
    const lastAddedComment = ref()

    // actions

    // list all task comments
    const getTaskComments = async (taskId) => {
        try {
            loading.value = true;
            const response = await authApi.get(`${URL}/${taskId}/comments`, {
                params: {
                    companyId: company_id.value,
                },
            });
            if (response.statusCode === 200) {
                comments.value = response.data;
            }
            return response.data;
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch task comments');
        } finally {
            loading.value = false;
        }
    };

    const addTaskComment = async (taskId) => {
        try {
            const response = await authApi.post(`${URL}/${taskId}/comments`, {
                ...comment.value,
                company_id: company_id.value,
            });
            if (response.statusCode === 201) {
                lastAddedComment.value = response.data
                initComment();
                // reload all comments
                await getTaskComments(taskId);
                showToast(response.toast, 'Comment have been added');
                return true;
            }
            return false;
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to add comment');
        }
    };

    const getlatest5CommentsByTask = async (taskId) => {
        // console.log('Loading 5 comments for this taskID', taskId);
        const taskComments = await getTaskComments(taskId);

        let sortedComments = taskComments.sort((a, b) => b - a);
        // now return only 5 latest
        return sortedComments.slice(0, 5);
    };

    // reinit comment
    const initComment = () => {
        comment.value.company_id = null;
        comment.value.comment = null;
        comment.value.type = null;
        comment.value.attachments = [];
    };

    // reinit comments
    const initComments = () => {
        comments.value = [];
    };

    return {
        loading,
        // states
        comment,
        comments,
        // actions
        getTaskComments,
        addTaskComment,
        getlatest5CommentsByTask,
        lastAddedComment,

        // helpers
        // initComment,
        initComments,
    };
});
